import Swiper, { FreeMode, Grid, Mousewheel, Scrollbar } from "swiper";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/grid";
import "swiper/css/scrollbar";

export default class Music {
    constructor() {
        this.$slider = document.querySelector(".js-howto4th-music");

        if (!this.$slider) return;

        this.swiper = new Swiper(this.$slider, {
            modules: [FreeMode, Grid, Mousewheel, Scrollbar],
            slidesPerView: "auto",
            spaceBetween: 8,
            breakpoints: {
                769: {
                    grid: {
                        rows: 2,
                        fill: "row",
                    },
                    spaceBetween: 4,
                },
            },
            grid: {
                rows: 2,
                fill: "row",
            },
            freeMode: true,
            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },
            scrollbar: {
                el: this.$slider.parentElement.querySelector(".swiper-scrollbar"),
                draggable: true,
            },
        });
    }
}
